module.exports = __webpack_public_path__ + "img/nail2.439b7360.jpg";